import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const DropdownIcon = ({
	color = 'white',
	isInverted = false,
}: {
	color?: string;
	size?: string;
	isInverted?: boolean;
}) => {
	return (
		<Icon
			width="12px"
			height="auto"
			viewBox="0 0 12 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			transform={isInverted ? 'rotate(180deg)' : 'unset'}
		>
			<path
				d="M1 1.5L6 6.5L11 1.5"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
